import React from "react";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useIntl } from "react-intl";
import usePermission from "./usePermission";
import { Modal } from "antd";
import { usePageNavigate } from "@/components";
import { matchRoutes } from 'react-router-dom';
import routes from '@/config/routes';

type PermissionLinkProps = React.PropsWithChildren<{
  to: string;
  className?: string;
  target?: '_blank';
  /**
   * 跳转前的校验
   * 若返回 false 则停止跳转。
   * 支持返回一个 Promise 对象，Promise 对象 reject 时则停止跳转。
   */
  beforeJump?: (to: string) => boolean | void | Promise<void>;
  /**
   * 跳转后的回调
   */
  afterJump?: (to: string) => void;
}>;

const PermissionLink = observer(({
  children,
  to,
  className,
  target,
  beforeJump,
  afterJump,
}: PermissionLinkProps) => {
  const intl = useIntl();

  const { hasRoutePermission } = usePermission();
  const navigate = usePageNavigate();
  const store = useLocalObservable(() => ({
    async jumpTo() {
      if (beforeJump) {
        const checkResult = await beforeJump(to);
        if (checkResult === false) {
          return;
        }
      }
      const canAccess = hasRoutePermission(to);
      if (canAccess) {
        navigate(to, { target });
        afterJump?.(to);
      } else {
        const menuName = (matchRoutes(routes, to) || [])
          .filter((d) => d.route?.path && d.route?.path != '*')
          .map((d) => d.route?.name)[0];
        Modal.info({
          title: intl.formatMessage(
            { defaultMessage: '当前账号暂无<strong>{menuName}</strong>菜单权限，请联系主账号开启' },
            {
              menuName: menuName || '',
              strong: (chunks: React.ReactNode[]) => <strong>{chunks}</strong>,
            },
          ),
        });
      }
    }
  }));

  return (
    <a className={className || 'bg-red-600'}
      onClick={store.jumpTo}
    >
      {children}
    </a>
  );
});

export default PermissionLink;
